import { Route, Routes } from "react-router-dom";
import Lecturer from "./Pages/Lecturer/Lecturer";
import VirtualClassL from "./Components/VirtualClassL/VirtualClassL";
import AsgmntL from "../src/Components/AsgmntL/AsgmntL"
import Users from "./Components/Users/Users";
import Resources from "./Components/Resources/Resources";
import Quizzes from "./Components/Quizzes/Quizzes";

import VirtualClassS from "./Components/VirtualClassS/VirtualClassL";
import AsgmntS from "../src/Components/AsgmntS/AsgmntL"
import UsersS from "./Components/UsersS/Users";
import ResourcesS from "./Components/ResourcesS/Resources";
import QuizzesS from "./Components/QuizzesS/Quizzes";





function App() {
  return (

          <>   

              <Routes>   

                <Route path="/" element={<Lecturer/>}> 
                      <Route index element={<VirtualClassL/>}  />
                      <Route path="/VirtualClassL"  element={<VirtualClassL/>}> 

                      </Route>
                      <Route path="/AsgmntL"  element={<AsgmntL/>}> 

                      </Route>
                      <Route path="/Users"  element={<Users/>}> 

                      </Route>
                      <Route path="/Resources"  element={<Resources/>}> 

                      </Route>
                      <Route path="/Quizzes"  element={<Quizzes/>}> 

                      </Route>

                
                      <Route path="/VirtualClassS"  element={<VirtualClassS/>}> 

                      </Route>
                      <Route path="/AsgmntS"  element={<AsgmntS/>}> 

                      </Route>
                      <Route path="/UsersS"  element={<UsersS/>}> 

                      </Route>
                      <Route path="/ResourcesS"  element={<ResourcesS/>}> 

                      </Route>
                      <Route path="/QuizzesS"  element={<QuizzesS/>}> 

                      </Route>

                  
                </Route>

                <Route path="/Lecturer" element={<Lecturer/>}> 

                    <Route index element={<VirtualClassL/>}> 

                    </Route>

                </Route>

                {/* <Lecturer/> */}

              </Routes>

              
                
          </>

  );
}

export default App;
